exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation-overlay{visibility:hidden;position:fixed;width:100vw;height:100vh;z-index:1;top:0;left:0;opacity:0;transition:opacity .2s,visibility 0s .2s;background:#004373}.navigation-overlay.active{visibility:visible;opacity:1;transition:opacity .2s}body.noscroll{overflow:hidden;width:100vw;height:calc(100vh - 64px);height:calc(var(--vh, 1vh)*100 - 64px)}", ""]);

// exports
